<!-- 
  提交访客计划 & 添加协同人 & 详情页添加协同人
 -->

<template>
  <div class="team-person">
    <el-dialog :title="this.module === 'distribution' ? '客户分配' : '选择团队'" :visible.sync="dialogVisible" :modal="modal" width="700px">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px" class="custom-form">
        <el-form-item label="筛选部门">
          <el-cascader
          clearable
          :options="form.departmentTree"
          change-on-select
          @change="chooseDepart"
          filterable
          placeholder="请选择筛选部门"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="选择员工" prop="selectedUsers">
          <el-select
            v-model="form.selectedUsers"
            :multiple="module !== 'transfer'"
            filterable
            remote
            :placeholder="placeholder"
            :remote-method="remoteMethod"
            @blur="blurSele"
            :loading="loading">
            <el-option
              v-for="item in userList"
              :key="item.userId"
              :label="item.value"
              :value="item.userId">
              <dl class="custom-option">
                <dt class="title">{{item.value}}</dt>
                <dd class="avatar">
                  <img :src="item.avatar" width="32" height="32">
                </dd>
                <dd class="department">
                  <span v-for="d in item.department">{{d}}</span>
                </dd>
              </dl>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit" :disabled="isDisabled">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'
import { mapGetters, mapActions } from 'vuex'
import * as common from 'src/config/common-config'

export default {
  created () {
    this.dialogVisible = true
    if (this.module !== 'transfer') {
      this.rules.selectedUsers = { type: 'array', required: true, message: '请选择负责人', trigger: 'change' }
    } else {
      this.rules.selectedUsers = { required: true, message: '请选择负责人', trigger: 'change' }
    }
    this.getUserList()
    this.getDepartmentList()
    this.makeopUUID()
  },
  props: {
    selectIds: {
      required: true
    },
    transferId: {
      required: false
    },
    module: {
      type: String,
      required: true
    },
    // 是否显示遮罩
    modal: {
      type: Boolean,
      default: true
    },
    // 是否有从详情页传送过来的moduleName
    detailModule: {
      type: String,
      default: ''
    },
    saleTeams: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      userList: [],
      form: {
        selectedUsers: [],
        departmentTree: [] // 筛选的部门
      },
      chooseDep: '', // 选择的部门
      searchUser: '', // 搜索的人员
      rules: {},
      moduleApi: common.moduleApi,
      isDisabled: false,
      opUUID: ''
    }
  },
  computed: {
    ...mapGetters([
      'moduleName'
    ]),
    placeholder () {
      if (this.module === 'distribution' || this.module === 'manager') {
        return '选择负责人，输入关键词可快速搜索'
      } else {
        return '选择协同人，输入关键词可快速搜索'
      }
    }
  },
  methods: {
    ...mapActions([
      'updateSelectrows'
    ]),
    // 远程搜索
    remoteMethod (query) {
      this.loading = true
      this.getUserList(query, this.chooseDep)
    },
    blurSele () { // 远程搜索失去焦点后，重新请求列表
      this.getUserList('', this.chooseDep)
    },
    // 获取部门列表
    getDepartmentList () {
      let url = '/user/getDepartmentsAjax.html'
      api.post(url, {}, (data) => {
        this.transformDepTree(data.result, this.form.departmentTree)
      })
    },
    transformDepTree (arr, newArr) { // 将部门数据转换成级联选择器需要的格式
      arr.forEach((item, index) => {
        newArr.push({
          'label': item.name,
          'value': item.id
        })
        if (item.childList) {
          newArr[index].children = []
          this.transformDepTree(item.childList, newArr[index].children)
        }
      })
    },
    chooseDepart (dep) { // 选择部门
      this.chooseDep = dep[dep.length - 1]
      this.getUserList('', this.chooseDep)
    },
    // 获取员工数据
    getUserList (query, dep) {
      let url = `/user/getStaffsAjax.html`
      let params = {
        pageSize: 100,
        nameLike: query || '',
        departmentId: dep || ''
      }
      api.post(url, params, (data) => {
        this.loading = false
        this.userList = data.result
      })
    },
    // 根据时间戳生成hash
    makeopUUID () {
      let d = new Date()
      this.opUUID = d.getTime()
    },
    // 提交
    handleSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.sendData()
        } else {
          Message({
            type: 'error',
            message: '输入有误，请检查后重新提交！'
          })
          return false
        }
      })
    },
    sendData () {
      let url, params
      // 分配
      if (this.module === 'distribution') {
        url = `/customerApi/customerDistribution.html`
        params = {
          customers: this.selectIds,
          isPublic: 0,
          staffIds: this.form.selectedUsers
        }
      // 列表页 添加协同人
      } else if (this.module === 'addTeamPerson') {
        url = `/staffApi/batchAddMyTeam.html`
        params = {
          refIds: this.selectIds,
          refStaffs: this.form.selectedUsers
        }
      } else if (this.module === 'cooperative') {
        url = `/staffApi/addMyTeam.html`

        // 如果有从详情页传过来的detailModule
        let mn = this.detailModule || this.moduleName
        params = {
          refType: this.moduleApi[mn],
          refId: this.selectIds,
          refStaffs: this.form.selectedUsers
        }
      } else if (this.module === 'manager') {
        url = `/staffApi/addMainMyTeam.do`

        // 如果有从详情页传过来的detailModule
        let mn = this.detailModule || this.moduleName
        params = {
          refType: this.moduleApi[mn],
          refId: this.selectIds,
          refStaffs: this.form.selectedUsers
        }
      } else if (this.module === 'transfer') {
        // 对移交客户进行判重处理
        let ifExit = false
        this.saleTeams.forEach(item => {
          if (this.form.selectedUsers === item.userId) {
            ifExit = true
            Message('您选择的员工已是该团队成员')
            return
          }
        })
        if (ifExit) {
          return
        }
        url = `/customer/customerHandoverSave.do`

        params = {
          customerIdList: this.transferId ? [this.selectIds] : this.selectIds,
          targetUserId: this.form.selectedUsers,
          fromUserId: this.transferId,
          opUUID: this.opUUID
        }
      }
      this.isDisabled = true
      const that = this
      api.post(url, params, (data) => {
        Message({
          type: data.warning === 1 ? 'warning' : 'success',
          message: data.msg || '保存成功！',
          duration: 1000,
          onClose: function () {
            // 同步到vuex
            that.updateSelectrows({del: 'all'})
            that.dialogVisible = false
            if (that.module === 'distribution') {
              that.$emit('distribution')
              return
            }
            setTimeout(() => {
              that.isDisabled = false
            }, 1000)
            that.$emit('refresh')
            that.makeopUUID()
          }
        })
      }, () => {
        setTimeout(() => {
          that.isDisabled = false
        }, 1000)
      })
    }
  },
  watch: {
    dialogVisible () {
      if (this.dialogVisible === false) {
        this.$emit('closeDialog')
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .team-person {
    .el-dialog--small {
      width: 600px;
    }
  }
  .custom-option {
    position: absolute;
    box-sizing: border-box;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    padding-left: 50px;
    .avatar {
      position: absolute;
      left: 8px;
      top: 2px;
      img {
        display: block;
      }
    }
    .title {
      font-size: 14px;
      line-height: 1.3;
    }
    .department {
      font-size: 12px;
      line-height: 16px;
      height: 16px;
      color: #999;
      overflow: hidden;
      white-space: nowrap;
      text-overflow:ellipsis;
      span {
        margin-right: 2px;
        line-height: 16px!important;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// team-person.vue?6f84d354